import React from 'react'
import PropTypes from 'prop-types'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import ProgressBar from 'react-bootstrap/ProgressBar'
import Navbar from 'react-bootstrap/Navbar'
import Container from 'react-bootstrap/Container'
import Slider from 'react-slick'
import RadioButtons from './questionnaire/RadioButtons'
import Email from './questionnaire/Email'
import Text from './questionnaire/Text'
import TextArea from './questionnaire/TextArea'
import Birthdate from './questionnaire/Birthdate'
import Select from './questionnaire/Select'
import WeightInput from './questionnaire/WeightInput'
import Checkboxes from './questionnaire/Checkboxes'
import Message from './questionnaire/Message'
import axios from 'axios'
import IntroImage from "../../assets/images/screener_intro.png";

class Questionnaire extends React.Component {
  state = {
    questions: this.props.questions || [],
    currentQuestion: this.props.current_question,
    disqualifiers: [],
    uncertainties: []
  }

  numQuestionsAnswered = () => {
    return(this.state.questions.map(question => (question.value)).filter(e => e != null).length)
  }

  goNext = () => {
    // Ensures questions are not accidentally skipped over in the Questionnaire
    if (this.numQuestionsAnswered() < this.state.currentQuestion) return;

    this.setState({ currentQuestion: this.state.currentQuestion + 1 }, () => {
      this.slider.slickGoTo(this.state.currentQuestion)
      $('html, body').animate({ scrollTop: 0 });
    })
  }

  goBack = () => {
    this.setState({ currentQuestion: this.state.currentQuestion - 1 }, () => {
      this.slider.slickGoTo(this.state.currentQuestion)
    })
  }

  progress = () => {
    var offset = this.props.intro ? 1 : 0;
    return(((this.state.currentQuestion - offset) * 100) / this.state.questions.length)
  }

  isLastQuestion = () => {
    return(this.state.currentQuestion == this.state.questions.length)
  }

  ///////////////////////////////////////////////
  // Event Handlers
  ///////////////////////////////////////////////

  submitAnswer = (questionId, answer) => {
    let callback_path = this.props.callback_path

    // Keep track of user's selected answers
    this.state.questions.find(question => question.id == questionId)["value"] = answer
    let answers = this.state.questions.map(question => ({ [question.id]: question.value }))

    // Persist answers to the database
    axios.patch(this.props.update_path, { questionnaire: { answers: answers } }, {
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      }
    }).then((response) => {
      // Update the questionnaire state with the latest questions
      this.setState({
        questions: response.data.questions,
        disqualifiers: response.data.disqualifiers,
        uncertainties: response.data.uncertainties
      }, () => {
        // If the questionnaire is finished, redirect to the callback path
        if(response.data.status == "finished"){
          $('form').animate({ opacity: 0, top: '500px' }, 250, 'swing', () => {
            window.location = callback_path || response.data.callback_url
          })
          return  // prevent slide update
        }

        // Update slide
        if(this.state.currentQuestion < this.state.questions.length) {
          this.goNext()
        }
      })
    })

  }

  ///////////////////////////////////////////////
  // DOM
  ///////////////////////////////////////////////

  renderInput = (question) => {
    console.log(question.type)
    switch(question.type) {
      case 'text': return <Text question={question} onSubmit={this.submitAnswer} next_button={this.props.next_button} />
      case 'radio': return <RadioButtons question={question} onSubmit={this.submitAnswer} />
      case 'email': return <Email question={question} onSubmit={this.submitAnswer} next_button={this.props.next_button} />
      case 'textarea': return <TextArea question={question} onSubmit={this.submitAnswer} next_button={this.props.next_button} />
      case 'birthdate': return <Birthdate question={question} onSubmit={this.submitAnswer} next_button={this.props.next_button} />
      case 'checkboxes': return <Checkboxes question={question} onSubmit={this.submitAnswer} next_button={this.props.next_button} />
      case 'select': return <Select question={question} onSubmit={this.submitAnswer} next_button={this.props.next_button} locale={this.props.locale} />
      case 'weight': return <WeightInput question={question} onSubmit={this.submitAnswer} next_button={this.props.next_button} pounds_label={this.props.pounds_label} ounces_label={this.props.ounces_label} />
      case 'message': return <Message question={question} />
      default: console.error("unknown question type: ", question)
    }
  }

  renderBackButton = (index) => {
    if(index >= (this.props.intro ? 0 : 1)) {
      return(<Button variant="link" size="lg" className="w-100 text-decoration-none" onClick={this.goBack}>{ this.props.back_button || "Back" }</Button>)
    }
  }

  renderQuestion = (question, index) => {
    return(
      <div key={question.id}>
        <div className="container pt-3">
          <header className="mb-3">
            <h4 className="mb-0">{ question.type == 'message' ? question.prompt : index + 1 + ". " + question.prompt }</h4>
            <small className="text-muted">{ question.explanation }</small>
          </header>
          {this.renderInput(question)}
          {this.renderBackButton(index)}
        </div>
      </div>
    )
  }

  renderIntro = (intro) => {
    if(intro){
      return(
        <div key='introduction'>
          <div id="questionnaire-intro-body" className="m-auto max-w-768 px-3">
            <header className="mb-4 text-center">
              <div className="h3 fw-normal mb-3">{intro.title}</div>
              <h4 className="fw-normal text-muted mb-0">{intro.subtitle}</h4>
            </header>
            <img src={IntroImage} alt="Parent and child on couch"/>
            <small className="text-muted mt-3">{intro.text}</small>
            <Button variant="primary" size="lg" className="mb-3" onClick={this.goNext}>{ this.props.begin_button || "Begin" }</Button>
          </div>
        </div>
      )
    }
  }

  renderTitle = () => {
    if(this.state.currentQuestion == 0 && this.props.intro) {
      return(<h4>{this.props.intro.nav}</h4>)
    } else if(this.props.intro) {
      return(<h4>{ this.props.question_title || "Question" } {this.state.currentQuestion}/{this.state.questions.length}</h4>)
    } else {
      return(<h4>{ this.props.question_title || "Question" } {this.state.currentQuestion + 1}/{this.state.questions.length}</h4>)
    }
  }

  renderDisqualifiers = () => {
    if(this.state.disqualifiers && this.state.disqualifiers.length > 0) {
      return(
        <div className="bd-callout bd-callout-error">
          <ul className="mb-0">
            {this.state.disqualifiers.map((dq, index) => (
              <li key={index} className="disqualifier">
                {dq}
              </li>
            ))}
          </ul>
        </div>
      )
    }
  }

  renderUncertainties = () => {
    if(this.state.uncertainties && this.state.uncertainties.length > 0) {
      return(
        <div className="bd-callout bd-callout-warning">
          <ul className="mb-0">
            {this.state.uncertainties.map((uq, index) => (
              <li key={index} className="uncertainty">
                {uq}
              </li>
            ))}
          </ul>
        </div>
      )
    }
  }

  ///////////////////////////////////////////////
  // Lifecycle
  ///////////////////////////////////////////////

  componentDidMount() {
    this.slider.slickGoTo(this.state.currentQuestion)
  }

  render() {
    var slickOptions = {
      accessibility: false,
      dots: false,
      arrows: false,
      infinite: false,
      draggable: false,
      swipe: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 250,
      easing: 'swing',
      cssEase: 'ease-in-out',
      adaptiveHeight: true
    }

    return (
      <div className={`slide-${this.state.currentQuestion}`}>
        <Navbar id='questionnaire-title' bg='light'>
          <Container fluid className='justify-content-center'>
            {this.renderTitle()}
          </Container>
        </Navbar>

        <ProgressBar id='navbar-progress' now={this.progress()} />
        <Form style={{ position: 'relative' }} data-wtf='main form'>
          <Slider ref={slider => (this.slider = slider)} {...slickOptions}>
            {this.renderIntro(this.props.intro)}
            {this.state.questions.map((question, index) => this.renderQuestion(question, index))}
          </Slider>
        </Form>
        {this.renderDisqualifiers()}
        {this.renderUncertainties()}
      </div>
    )
  }
}

Questionnaire.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default Questionnaire

